export function transformFirstInvoiceDateUIToModel(
  existingFirstInvoiceDate?: string | null | undefined
): string {
  if (!existingFirstInvoiceDate) {
    return new Date().toISOString();
  }
  return existingFirstInvoiceDate;
}
